import React, { Component } from "react";

import { Modal, Segment } from "semantic-ui-react";
import moment from 'moment';

class GlobalPromoModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      b_days: 0,
      b_hours: 0,
      b_mins: 0,
      b_secs: 0,
      isPromoExpired: false,
      isFinalCallExpired: false,
    };

    this.counter_val = null;
    this.startCounter = this.startCounter.bind(this);
    this.setTimerValue = this.setTimerValue.bind(this);
    this.getFormattedDate = this.getFormattedDate.bind(this);
  }

  componentDidMount() {
    const dateFuture = new Date(this.getFormattedDate(this.props.promoData.expiry_date));
    this.startCounter(dateFuture);
  }

  getTimeDifference(dateFuture) {
    const dateNow = new Date();
    return dateFuture.getTime() - dateNow.getTime();
  }

  startCounter(dateFuture) {
    let amount, days, hours, mins, secs;

    amount = this.getTimeDifference(dateFuture);
    //calc milliseconds between dates 
    days = 0; hours = 0; mins = 0; secs = 0;

    // time is already past
    if (amount <= 0) {
      this.setTimerValue(0, 0, 0, 0);

      this.setState({
        isPromoExpired: true
      })

      if (this.state.promoData && this.state.promoData.expiry_date && !this.state.isPromoExpired) {
        const expiryDate = new Date(this.getFormattedDate(this.state.promoData.expiry_date));
        if (this.getTimeDifference(expiryDate) < 0) {
          this.setState({ isFinalCallExpired: true, isPromoExpired: false })

        }
        else {
          this.counter_val = setTimeout(() => {
            this.startCounter(expiryDate);

          }, 1000);
        }
      }
      else {
        this.setState({ isFinalCallExpired: true, isPromoExpired: false })
      }
    }

    else {
      amount = Math.floor(amount / 1000);//convert to seconds from milliseconds
      days = Math.floor(amount / 86400);//days (60*60*24)
      amount = amount % 86400;

      hours = Math.floor(amount / 3600);//hours (60*60)
      amount = amount % 3600;

      mins = Math.floor(amount / 60);//minutes (60)
      amount = amount % 60;

      secs = Math.floor(amount);//seconds
      this.setTimerValue(days, hours, mins, secs)

      this.counter_val = setTimeout(() => {
        this.startCounter(dateFuture)
      }, 1000);
    }
  }

  setTimerValue(days, hours, mins, secs) {
    let v_days, v_hours, v_mins, v_secs;

    v_days = days < 10 ? ("0" + days) : days;
    v_hours = hours < 10 ? ("0" + hours) : hours;
    v_mins = mins < 10 ? ("0" + mins) : mins;
    v_secs = secs < 10 ? ("0" + secs) : secs;

    this.setState({
      b_days: v_days,
      b_hours: v_hours,
      b_mins: v_mins,
      b_secs: v_secs,
    })
  }

  getFormattedDate(date) {
    return moment(date).toDate();
  }
  render() {
    const { open, closeModal, promoData } = this.props;
    const { b_days, b_hours, b_mins, b_secs } = this.state;
    return <Modal open={open} onClose={closeModal} basic closeOnDimmerClick={false} className='modal__building-list'>
      <Segment inverted className="global-promo w-400 py-7">
        <Modal.Header className="pb-3">

        </Modal.Header>
        <Modal.Content className="ui centered grid mx-0" scrolling>
          <div className="text-uc text-prime f-size--12 itc-mdbold text-center">{promoData.header}</div>
          <h2 className="bold text-white text-center text-uc px-4 mt-3" style={{whiteSpace: "pre-wrap"}}
          dangerouslySetInnerHTML={{__html: promoData.title}}>
          </h2>
          <div className="text-left my-6 px-xs-0 w-full">
            <div className="text-uc f-size--12 itc-mdbold" style={{whiteSpace: "pre-wrap"}}>{promoData.subtitle}</div>
            <div className="f-size--14 text-grey7 mt-4 line-height-21px" style={{whiteSpace: "pre-wrap"}} 
            dangerouslySetInnerHTML={{__html: promoData.description}}>
            </div>
          </div>
          <div className="w-full px-xs-0 ">
            <div className="promo__expire pb-4">
              <div className="promo__expire-block">
                <span className="text-1">{b_days}</span>
                <span className="text-2">{b_days > 1 ? 'Days' : 'Day'}</span>
              </div>
              <div className="promo__expire-block">
                <span className="text-1">{b_hours}</span>
                <span className="text-2">hrs</span>
              </div>
              <div className="promo__expire-block">
                <span className="text-1">{b_mins}</span>
                <span className="text-2">min</span>
              </div>
              <div className="promo__expire-block">
                <span className="text-1">{b_secs}</span>
                <span className="text-2">secs</span>
              </div>
            </div>
          </div>

          <div className="close" onClick={closeModal}>
            <span className="promo__times text-white cursor-pointer">
              &times;
        </span>
          </div>
        </Modal.Content>
      </Segment>
    </Modal>
  }
}

export default GlobalPromoModal;


// WEBPACK FOOTER //
// ./src/components/global-promo/GlobalPromoModal.js